// @flow
import * as React from 'react';
import type { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { hideDownloadAppBanner } from '../../Index/actions';
import SectionIds from '../../tracking/SectionIds';
import messages from '../messages';
import StickyTopBanner from './index';
import { generateDownloadUrl } from '../../utils/downloadLinks';
import { configSelector } from '~/common/selectors/config';
import { trovitSelector } from '~/common/selectors/trovit';

type Props = {
  config: Object,
  trovit: Object,
  currentUrl: string,
  hideDownloadAppBanner: Function,
};

const { downloadAppTopBannerSlogan, downloadAppTopBannerCTA } = messages;

export class Component extends React.Component<Props> {
  handleClose = () => this.props.hideDownloadAppBanner();

  render(): React.Node {
    const { config, trovit, currentUrl } = this.props;
    const downloadAppUrl = generateDownloadUrl(
      config,
      trovit,
      currentUrl,
      SectionIds.APP_DOWNLOAD_SECTION_BUTTON
    );
    const verticalName = config.verticalName;
    const downloadAppTitle = messages[verticalName];

    return (
      <StickyTopBanner
        downloadAppUrl={downloadAppUrl}
        verticalName={verticalName}
        downloadAppTitle={<FormattedMessage {...downloadAppTitle} />}
        downloadAppSlogan={<FormattedMessage {...downloadAppTopBannerSlogan} />}
        downloadAppCTA={<FormattedMessage {...downloadAppTopBannerCTA} />}
        handleClose={this.handleClose}
      />
    );
  }
}

const mapStateToProps = state => ({
  config: configSelector(state),
  trovit: trovitSelector(state),
});

export const mapDispatchToProps = (dispatch: Dispatch<*>) => ({
  hideDownloadAppBanner: () => dispatch(hideDownloadAppBanner()),
});

const container = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);

container.displayName = 'DownloadAppTopBannerContainer';

export default container;



// WEBPACK FOOTER //
// ./app/DownloadAppBanner/TopBanner/container.js